export default {
  _id: '589c822f82d2f92a09e21bc4',
  availableLangs: ['th', 'en'],
  contacts: {
    phone: '092 592 2577',
    others: {
      th: 'หน้าสนามกลางจิระนคร',
      version: 2,
    },
    version: 1,
    diff: 1866,
  },
  coupons: [
    {
      _id: '932eab08-5ddc-4e04-a7b9-92ae9fe65bed',
      appearWhen: '2017-11-30T17:00:00.000Z',
      availableAmount: 9,
      description: {
        th: 'คูปอง500สวน',
      },
      lifetimeMinutes: 999,
      mainImageId: '5a0d641482d2f956e6f0b21f',
      quataAmount: 10,
      title: {
        th: 'V1',
      },
      validDateFrom: '2017-11-30T17:00:00.000Z',
      validDateTo: '2017-12-01T17:00:00.000Z',
      validDayOfWeek: [0, 1, 2, 4, 3, 5, 6],
      validTimeFrom: '2017-12-01T10:18:00.000Z',
      validTimeTo: '2017-11-16T16:55:00.000Z',
      version: 2,
    },
  ],
  description: {},
  galleryImages: [
    {
      mainImageId: '58bd7eca82d2f97801b3bf38',
      title: {
        th: 'สุดยอดเมนู',
        version: 2,
      },
    },
    {
      mainImageId: '58bd7ed382d2f97801b3bf39',
    },
    {
      mainImageId: '58bd7eda82d2f97801b3bf3a',
      title: {
        th: 'บรรยากาศเต็มอิ่ม',
        version: 2,
      },
    },
    {
      mainImageId: '5915e3b882d2f923ddc5fdcb',
      title: {
        th: 'อาหารแสนอร่อย',
        version: 2,
      },
    },
    {
      mainImageId: '5915e3ce82d2f923ddc5fdcc',
      title: {
        th: 'พ่อครัว',
        version: 2,
      },
    },
  ],
  highlightSentence: {
    th: 'The Oasis for Wine & Music Lovers',
  },
  links: [
    {
      description: {
        th: 'รายละเอียด',
        version: 2,
      },
      externalUrl: 'www.google.com',
      title: {
        th: 'ทดสอบ',
        version: 2,
      },
      version: 2,
    },
  ],
  location: {
    latitude: 7.02002507014555,
    longitude: 100.470469594002,
    streetAddress: {
      th: 'Tempo Cafe, Nipatsongkroa 1, เทศบาลนครหาดใหญ่',
    },
    diff: 1866,
  },
  openingHours: {
    th: 'เปิดบริการทุกวัน 17:00 - 01:00 น.',
    en: 'every day',
    version: 1,
  },
  promotions: [
    {
      _id: '932eab08-5ddc-4e04-a7b9-92ae9fe65bed',
      appearWhen: '2017-11-30T17:00:00.000Z',
      description: {
        th: 'คูปอง500สวน',
      },
      title: {
        th: 'V1',
      },
      validDateFrom: '2017-11-30T17:00:00.000Z',
      validDateTo: '2017-12-01T17:00:00.000Z',
      validDayOfWeek: [0, 1, 2, 4, 3, 5, 6],
      validTimeFrom: '2017-12-01T10:18:00.000Z',
      validTimeTo: '2017-11-16T16:55:00.000Z',
      version: 2,
    },
  ],
  shortDescription: {},
  tags: ['อาหารฝรั่ง'],
  title: {
    th: "Tempo Cafe'",
    en: 'Tempo',
    version: 1,
  },
  town: 'hatyai',
  version: 1867,
  mainImageId: '59ad761e82d2f95c7ec6fa23',
  editorNotes: {
    th: '1',
  },
}



// WEBPACK FOOTER //
// ./src/portal.mock.js